import { Flex } from '@ui-library/misc';
import { ColumnProps } from 'antd/lib/table';
import React from 'react';
import Tooltip from '@ui-library/tooltip';
import { FixMe } from '@utils/types';
import { useMappingState } from '../tableMappingProvider';
import EditColumn from './editColumn/editColumn';
import { MappingTable, CheckRow, TableViewWrapper } from './style';
import TableHeader from './tableHeader';
import AddColumn from './addColumn';
import classes from '../tableMapping.module.scss';
import ErrorLabel from '@ui-library/errorLabel';

const TableView: React.FC = () => {
  const mappingState = useMappingState();
  const {
    tableData,
    setSelectedRow,
    selectedColumns,
    searchKeyword,
    renamedRows,
    editingRow,
    constantsConfig,
    viewOnly,
  } = mappingState;
  const columns = React.useCallback<() => ColumnProps<{ column: string; sample: FixMe }>[]>(
    () => [
      {
        title: 'COLUMN',
        dataIndex: 'column',
        width: 150,
        render: (col, row: Record<string, unknown>) => {
          if (!col) {
            return '-';
          }
          const disableCheckBox =
            viewOnly ||
            !renamedRows[col.replace(/\./g, '\\.')] ||
            renamedRows[col.replace(/\./g, '\\.')].length === 0;
          let checkBox = (
            <CheckRow
              disabled={disableCheckBox}
              checked={selectedColumns.includes(col)}
              onChange={() => setSelectedRow(col)}
            />
          );
          if (disableCheckBox) {
            checkBox = viewOnly ? (
              checkBox
            ) : (
              <Tooltip title="You need at least one trait">{checkBox}</Tooltip>
            );
          }

          return {
            props: {},
            children: (
              <Flex alignItems="center">
                {checkBox}
                <div
                  className={`${classes.column_name} ${
                    row.unidentified ? classes.unidentified : ''
                  }`}
                >
                  {col}
                </div>
              </Flex>
            ),
          };
        },
      },
      {
        title: 'JSON TRAIT KEY',
        dataIndex: 'column',
        width: 150,
        render: (column, { trait }: FixMe) => {
          const isConstant = !column;
          return {
            children: isConstant ? (
              trait
            ) : (
              <EditColumn
                key={column}
                defaultValue={column.replace(/\./g, '\\.')}
                viewOnly={viewOnly}
              />
            ),
          };
        },
      },
      {
        width: 150,
        title: 'SAMPLE DATA',
        dataIndex: 'sample',
        render: (value, { unidentified }: Record<string, unknown>) => {
          if (unidentified) {
            return <ErrorLabel error errorMessage="Column not found" />;
          }
          return typeof value === 'undefined' ? '-' : String(value);
        },
      },
    ],
    [editingRow, selectedColumns, renamedRows, viewOnly],
  );

  const currentColumns = Object.keys(tableData || {});
  const removedColumns = selectedColumns
    .filter((col) => !currentColumns.includes(col))
    .map((col) => ({ column: col, unidentified: true }));
  const normalizedData =
    (tableData &&
      Object.keys(tableData).reduce((accum: FixMe, col) => {
        if (
          (searchKeyword && col.toLowerCase().includes(searchKeyword.toLowerCase())) ||
          !searchKeyword
        ) {
          accum = [...accum, { column: col, sample: tableData[col] }];
        }
        return accum;
      }, [])) ||
    [];

  let constants = constantsConfig?.map(({ key, value }) => ({
    trait: key,
    sample: value,
  }));
  if (searchKeyword) {
    constants = constants.filter((k) => k.trait.includes(searchKeyword.toLowerCase()));
  }
  const filteredRemovedColumns = searchKeyword
    ? removedColumns.filter(({ column }) =>
        column.toLowerCase().includes(searchKeyword.toLowerCase()),
      )
    : removedColumns;
  const allData = [...filteredRemovedColumns, ...normalizedData, ...constants];
  const filled = normalizedData && normalizedData.length > 7;
  return (
    <TableViewWrapper>
      <TableHeader />
      <MappingTable
        className="table-view_table"
        scroll={(filled && { y: 288 }) || undefined}
        filled={filled}
        columns={columns()}
        pagination={false}
        dataSource={allData}
      />
      <div style={{ marginBottom: 12 }} />
      {!viewOnly ? <AddColumn /> : null}
      {removedColumns.length > 0 && (
        <ErrorLabel
          error
          errorMessage={`${String(
            removedColumns.length,
          )} column(s) not found. Remove them by deselecting.`}
        />
      )}
    </TableViewWrapper>
  );
};

export default TableView;
